// Global Instructions Rule Applied!
import { ProspectFields } from './fieldConfigs.ts'
import { AccountRecordFields } from '../../../state_manager/data_models/account_record.ts'
import { UserEntryFields } from '../../../state_manager/data_models/user_entry.ts'
import { CURRENCY_USD } from '../../../state_manager/globals.ts'
import { UNKNOWN_USER } from '../../../state_manager/constants/strings.ts'

/**
 * Get initial form data for new prospect
 */
export function getInitialFormDataForNew(): Record<string, any> {
  return {
    [ProspectFields.prospects__investor]: '',
    [ProspectFields.prog__is_new_investor]: false,
    [AccountRecordFields.accounts__name]: '',
    [AccountRecordFields.accounts__industry]: '',
    [AccountRecordFields.accounts__website]: '',
    [AccountRecordFields.accounts__domain]: '',
    [AccountRecordFields.accounts__business_address_1]: '',
    [AccountRecordFields.accounts__business_address_2]: '',
    [AccountRecordFields.accounts__business_city_code]: '',
    [AccountRecordFields.accounts__business_country_code]: '',
    [AccountRecordFields.accounts__business_stateprovince]: '',
    [AccountRecordFields.accounts__business_postalcode]: '',
    [AccountRecordFields.accounts__description]: '',
    [ProspectFields.prospects__fund]: '',
    [ProspectFields.pipeline_prospects__stage]: '',
    [ProspectFields.prospects__currency]: CURRENCY_USD,
    [ProspectFields.prospects__commitment]: '',
    [ProspectFields.prospects__allocation_available]: ''
  }
}

/**
 * Transform system user to form contact format
 */
export function transformSystemUserToContact(systemUser: any): any {
  return {
    label:
      systemUser[UserEntryFields.prog__display_name] || systemUser[UserEntryFields.contacts__email] || UNKNOWN_USER,
    value: systemUser[UserEntryFields.contacts__id] || '',
    email: systemUser[UserEntryFields.contacts__email] || '',
    full_name: systemUser[UserEntryFields.prog__display_name] || '',
    last_name: systemUser[UserEntryFields.contacts__last_name] || ''
  }
}
